import { forwardRef } from 'preact/compat';
import { useState }   from 'preact/hooks';
import dayjs          from 'dayjs';
import utc            from 'dayjs/plugin/utc';
import tz             from 'dayjs-timezone-iana-plugin';
import Popup          from 'reactjs-popup';
import popupStyles    from 'reactjs-popup/dist/index.css?inline';

import BxsDownArrow           from './icons/BxsDownArrow.jsx';
import { weekDayTranslTable } from '../helpers.js';


const TZ = 'Europe/Berlin';

dayjs.extend(utc);
dayjs.extend(tz);

function isStoreOpen(openingHours) {
  const now = dayjs().tz(TZ);
  const currentDay = now.format('dddd').toLowerCase();
  const currentTime = now.format('HH:mm');

  const dayHours = openingHours.find(day => day.day === currentDay);

  if (!dayHours || !dayHours.is_open) {
    return false;
  }

  const { start_time_1, end_time_1, start_time_2, end_time_2 } = dayHours;

  const isOpenInFirstPeriod = start_time_1 && end_time_1 && currentTime >= start_time_1 && currentTime <= end_time_1;
  const isOpenInSecondPeriod = start_time_2 && end_time_2 && currentTime >= start_time_2 && currentTime <= end_time_2;

  return isOpenInFirstPeriod || isOpenInSecondPeriod;
}

function getTodaysOpeningHours(openingHours) {
  const now = dayjs().tz(TZ);
  const currentDay = now.format('dddd').toLowerCase();

  const dayHours = openingHours.find(day => day.day === currentDay);

  if (!dayHours) {
    return null;
  }

  return dayHours;
}

const OpeningHoursButton = forwardRef(({ open, openingHours, toggle }, ref) => {
  const todaysHours = getTodaysOpeningHours(openingHours);
  const storeIsOpen = isStoreOpen(openingHours);

  return (
    <button className="text-green inline-flex justify-center" ref={ref} onClick={toggle}>
      <p className="mr-2 text-black"><b>Zur Zeit {storeIsOpen ? 'geöffnet' : 'geschlossen'}</b></p>
      <p>{todaysHours.start_time_1} - {todaysHours.end_time_1}</p>
      {todaysHours.start_time_2 && <p>{todaysHours.start_time_2} - {todaysHours.end_time_2}</p>}
      <BxsDownArrow class={`ml-1 align-top ${open ? 'rotate-180' : 'rotate-0'}`}/>
    </button>
  )
})

const OpeningHours = ({ openingHours }) => {
  const [tooltipOpen, setTooltipOpen] = useState(false)
  const toggleTooltip = () => setTooltipOpen(!tooltipOpen);

  const contentStyle = {
    borderRadius: '0',
    border: 'none',
    width: 'auto',
    boxShadow: 'none',
    minWidth: '400px',
    filter: 'drop-shadow(rgba(0, 0, 0, 0.1) 0px 10px 10px)',
    backgroundColor: 'rgb(249 247 244)'
  }

  return (
    <>
      <style type="text/css">{popupStyles}</style>
      <div class="inline-flex fixed-16 relative">
        <Popup arrow={false} contentStyle={contentStyle} open={tooltipOpen} closeOnDocumentClick={false}
               trigger={open => <OpeningHoursButton open={open} openingHours={openingHours} toggle={toggleTooltip}/>}
               position="bottom left">
          <ul class="py-[40px] px-[50px]">
            {openingHours.map(day => {
              return (
                <li class="flex justify-between py-2">
                  <span class="font-bold">{weekDayTranslTable[day.day].short}</span>
                  {day.is_open ? <span>
                {day.start_time_1} - {day.end_time_1}
                      {day.start_time_2 && <span>, {day.start_time_2} - {day.end_time_2}</span>}
              </span>
                    : 'Geschlossen'
                  }
                </li>
              )
            })}
          </ul>
        </Popup>
      </div>
    </>
  )
};

export default OpeningHours;
